import NativeSelect from './NativeSelect'
import CustomSelect from './Select'
import SelectContainer from './SelectContainer'
import MonthSelect from './MonthSelect'

const Select = SelectContainer({
  NativeComponent: NativeSelect,
  DefaultComponent: CustomSelect
})

Select.Month = MonthSelect

export default Select

export { MonthSelect }
